import React, { useState } from 'react';
import classNames from 'classnames';
import CadenceType from '../../../../interfaces/CadenceType';

import { CADENCE_VERBOSE_STRING } from '../../../utils/constants';

import WarningNote from '../WarningNote/WarningNote';

import styles from './OrderSummaryItem.module.css';

export interface OrderSummaryItemProps {
  id?: string | undefined;
  description: React.ReactElement | string;
  price?: React.ReactElement | string | number | undefined;
  crossedPrice?: React.ReactElement | string | undefined;
  redPrice?: boolean | undefined;
  fullWidthDescription?: boolean | undefined;
  quantity?: number;
  inventoryLimit?: number;
  imageUrl?: string;
  cadence?: CadenceType;
  rowClassName?: string;
  showWarningNote?: boolean;
  updateQuantity?: (
    variantId: string | undefined,
    quantity: number | undefined,
    inventoryLimit: number | undefined,
    setUpdating: (value: boolean) => void,
  ) => void;
}

const OrderSummaryItem: React.FunctionComponent<OrderSummaryItemProps> = ({
  id,
  description,
  price,
  crossedPrice,
  redPrice,
  fullWidthDescription,
  quantity,
  inventoryLimit,
  imageUrl,
  cadence,
  rowClassName,
  showWarningNote,
  updateQuantity,
}) => {
  const [updating, setUpdating] = useState(false);
  const imgAltText = typeof description === 'string' ? description : undefined;
  const priceStyles = redPrice ? `${styles.orderText} ${styles.orderTextRed}` : styles.orderText;
  const descriptionStyles = fullWidthDescription
    ? `${styles.orderText} ${styles.fullWidth}`
    : styles.orderText;
  const className = rowClassName ? styles[rowClassName] : '';
  const displayWarningNote =
    showWarningNote &&
    quantity !== undefined &&
    inventoryLimit !== undefined &&
    quantity > inventoryLimit;

  const handleClickUpdate = () => {
    if (updateQuantity) {
      updateQuantity(id, quantity, inventoryLimit, setUpdating);
    }
  };

  return (
    <>
      <div className={classNames(styles.orderRow, className)}>
        <div className={descriptionStyles}>
          {imageUrl && (
            <div className={styles.productImage}>
              <img src={imageUrl} alt={imgAltText} />
            </div>
          )}
          <p>
            {description}
            {cadence && ' Subscription'}
            {cadence && (
              <span className={styles.cadence}>Ships every {CADENCE_VERBOSE_STRING[cadence]}</span>
            )}
          </p>
        </div>
        <div className={styles.prices}>
          {quantity && <div className={styles.quantity}>x {quantity}</div>}
          {crossedPrice && (
            <div className={`${styles.orderText} ${styles.crossedPrice} ${styles.price}`}>
              {crossedPrice}
            </div>
          )}
          {price && <div className={classNames(priceStyles, styles.price)}>{price}</div>}
        </div>
      </div>
      {displayWarningNote && (
        <WarningNote
          inventoryLimit={inventoryLimit}
          disabledButton={updating}
          style={{ marginTop: 12 }}
          onClickButton={handleClickUpdate}
        />
      )}
    </>
  );
};

export default OrderSummaryItem;
